import { apiClient } from "api";
import { AccountStatus, TAccount, TAccountPicklist, TLocation } from "./models/types";
import dayjs from "dayjs";

export const getAllAccountsList = async (): Promise<TAccountPicklist[]> => {
  const response = await apiClient.get("accounts/list", {
    params: { includeInactiveAccounts: true }
  });
  return response.data;
};

export const getAccountById = async (accountId: string): Promise<TAccount> => {
  const response = await apiClient.get(`accounts/${accountId}`);
  return response.data;
};

export const toggleAccountStatus = async (account: TAccount): Promise<TAccount> => {
  const action = account.accountStatus == AccountStatus.Active ? "disable" : "enable";
  const response = await apiClient.put(`accounts/${account.accountId}/toggleStatus/${action}`);
  return response.data;
};

export const changePrimaryLocationForAccount = async (
  accountId: string,
  locationId: number
): Promise<TLocation[]> => {
  return apiClient.put(`accounts/${accountId}/changePrimaryLocation/${locationId}`);
};

export const addOrUpdateAccount = async (
  account: TAccount,
  isNew: boolean
): Promise<TAccount> => {
  const modifiedAccount = {
    ...account,
    effectiveDate: dayjs(account.effectiveDate).format("YYYY-MM-DD")
  };
  const response = await apiClient({
    method: isNew ? "post" : "put",
    url: `accounts`,
    data: modifiedAccount
  });
  return response.data;
};
